module.exports = __webpack_public_path__ + "img/quick-eco.72eea274.png";